import React, { useEffect, useState } from 'react';

interface TruncateTextProps {
    text: string;
    maxLength: number;
    breakpoints?: {
        md?: number;
        lg?: number;
        xl?: number;
        '2xl'?: number;
    };
}

export default function TruncateText({ text, maxLength, breakpoints }: TruncateTextProps) {
    const [currentMaxLength, setCurrentMaxLength] = useState(maxLength);

    useEffect(() => {
        const updateMaxLength = () => {
            const width = window.innerWidth;
            if (width >= 1536 && breakpoints?.['2xl']) {
                setCurrentMaxLength(breakpoints['2xl']);
            } else if (width >= 1280 && breakpoints?.xl) {
                setCurrentMaxLength(breakpoints.xl);
            } else if (width >= 1024 && breakpoints?.lg) {
                setCurrentMaxLength(breakpoints.lg);
            } else if (width >= 768 && breakpoints?.md) {
                setCurrentMaxLength(breakpoints.md);
            } else {
                setCurrentMaxLength(maxLength);
            }
        };

        updateMaxLength();
        window.addEventListener('resize', updateMaxLength);

        return () => {
            window.removeEventListener('resize', updateMaxLength);
        };
    }, [maxLength, breakpoints]);

    const truncatedText = text && text.length > currentMaxLength ? `${text.substring(0, currentMaxLength)}...` : text;
    return <>{truncatedText}</>;
}
